import { useNotification as useNotificationOriginal } from '../components/common';

interface TypedNotificationContext {
  showNotification: (message: string, type?: 'success' | 'error' | 'warning' | 'info', duration?: number, action?: any) => number | void;
  notifications: any[];
  hideNotification: (id: number) => void;
}

export const useTypedNotification = (): TypedNotificationContext => {
  return useNotificationOriginal() as unknown as TypedNotificationContext;
};